import { axiosInstance } from "./axios";

export const adminLogoutService = async () => {
  try {
    const { data } = await axiosInstance.post(`/admin/logout`);
    return { isSuccess: data.response.message === "successfully logged out." };
  } catch (e) {
    return {
      error: e.response.data,
    };
  }
};

export const adminInfoGetterService = () => {
  return localStorage.getItem("obenev-token");
};

export const userTypefoGetterService = () => {
  return localStorage.getItem("user-type");
};

export const permissionsGetterService = () => {
  const permissions = localStorage.getItem("permissions");
  return permissions ? JSON.parse(permissions) : [];
};

export const adminInfoStorageService = (admin) => {
  // console.log(admin,"admin")
  localStorage.setItem("obenev-token", admin.access_token);
  localStorage.setItem("user-type", admin.user_type);
  localStorage.setItem("permissions", JSON.stringify(admin.permissions || []));
};

export const adminInfoRemovalService = () => {
  localStorage.removeItem("obenev-token");
  localStorage.removeItem("user-type");
  localStorage.removeItem("permissions");
};

// export const fetchCountryCodes = async () => {
//   try {
//     const { data } = await axiosInstance.get(`/country/get`);
//     return data.response;
//   } catch (e) {
//     return { error: e.response.data.message };
//   }
// };
